export default __webpack_public_path__ + "static/Engineer_M_400x650px-59effedef0cdede413b9ab5e72048737.png";